import React from 'react';
import { ButtonWithContent } from '../../components/ButtonWithContent/ButtonWithContent';
import styled from '@emotion/styled';
import getBackgroundColor from '../../util/getBackgroundColor';

const ButtonWithContentContainer = styled.div`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ fontColor }) => fontColor};
`;

const ButtonWithContentWrapper = ({ card, fields }) => {
  const bgColor = getBackgroundColor(fields?.backgroundColor);

  return (
    <ButtonWithContentContainer
      className="button-with-content"
      bgColor={bgColor}
      fontColor={fields?.fontColor || '#000'}
    >
      <ButtonWithContent card={card} fields={fields} />
    </ButtonWithContentContainer>
  );
};

export { ButtonWithContentWrapper };
